import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CoinDepoDropdownComponent,
    },
  ],
})
export class CoinDepoDropdownComponent implements ControlValueAccessor, OnInit {
  @ContentChild('optionTemplate') optionTemplate!: TemplateRef<any>;
  @ContentChild('buttonTemplate') buttonTemplate!: TemplateRef<any>;
  @ContentChild('phTemplate') phTemplate!: TemplateRef<any>;
  @ContentChild('searchTemplate') searchTemplate!: TemplateRef<any>;

  @ViewChild('value', { static: false })
  private valueElem!: ElementRef<HTMLElement>;
  @Input() nameProp = 'name';
  @Input() valueProp = 'id';
  @Input() items: any[] = [];
  @Input() keyProp = 'deposit_plan_id';
  @Input() id!: string;
  @Input() classes!: string;
  @Input() placeholder = 'Select an option';
  @Input() selected: any;
  @Input() error!: string | null;
  @Input() wrong = false;
  @Input() titleSearch!: string;
  @Input() subtitleSearch!: string;
  @Output() selectedChange = new EventEmitter<any>();
  select = this.selectOption.bind(this);
  filter = this.filterItems.bind(this);
  clear = this.clearSearchInput.bind(this);
  scrollbarOptions = { theme: 'dark-thin' };

  unfilteredItems!: any[];

  constructor(
  ) {}

  ngOnInit(): void {
    this.unfilteredItems = this.items;
  }

  onChange!: (obj: any) => void;

  private value = null;

  selectOption(item: any): void {
    this.selected = item;
    this.selectedChange.emit(this.selected);
    this.onChange?.(this.selected[this.valueProp]);
  }

  dropdownTrackBy(index: number, item: any) {
    return item[this.keyProp];
  }

  writeValue(obj: any) {
    if (obj && this.items && this.items.length > 0) {
      this.selected = this.items.find((item) => item[this.valueProp] === obj);
    } else {
      this.selected = obj;
    }
    this.value = obj;
  }

  filterItems(event: InputEvent) {
    const inputElement = event.target as HTMLInputElement;
    const filteredItems = this.unfilteredItems
    .filter(
      item => item[this.valueProp].toLowerCase().includes(inputElement.value.toLowerCase())
    );

    if (filteredItems.length) {
      this.items = filteredItems
    }
  }

  clearSearchInput(idOfInput: string) {    
    const input = document.getElementById(idOfInput) as HTMLInputElement;
    
    if (input) {
      input.value = '';
      this.items = this.unfilteredItems;
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  setDisabledState(isDisabled: boolean) {}

  registerOnTouched(fn: any) {}
}
